import React from 'react'
import { Texto, BBDTag, Vertical, Horizontal } from '@gravitate-js/excalibrr'
import { LinkOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import type { MatchInvoice, MatchBol } from '@api/useSupplierReconciliation/types/match'

interface HelperFunctions {
  isItemMatched: (item: MatchInvoice | MatchBol) => boolean
  getLinkedNumbers: (item: MatchInvoice | MatchBol) => string[]
  findLinkedItems?: (item: MatchInvoice | MatchBol) => (MatchInvoice | MatchBol)[]
  combinedData?: {
    invoices: any[]
    bols: any[]
  }
}

interface DocumentNumberRendererProps {
  value: string
  data: MatchInvoice | MatchBol
  helpers: HelperFunctions
}

export function DocumentNumberRenderer({ value, data, helpers }: DocumentNumberRendererProps) {
  const number = value
  const item = data
  const isMatched = helpers.isItemMatched(item)

  if (isMatched) {
    // Get linked numbers using the existing helper
    const linkedNumbers = helpers.getLinkedNumbers(item)

    // Create tooltip content showing linked items
    const tooltipContent = linkedNumbers.length > 0 ? `Matched to: ${linkedNumbers.join(', ')}` : 'Matched document'

    // Show the tag with icon and text as children
    return (
      <Tooltip title={tooltipContent}>
        <BBDTag icon={<LinkOutlined />} appearance='primary'>
          {number}
        </BBDTag>
      </Tooltip>
    )
  }

  return (
    <Texto category='p2' weight='500'>
      {number}
    </Texto>
  )
}
